import { html, LitElement, nothing } from 'lit';

import Styles from './vm-video-comments-list.scss';

export default class VmVideoCommentsList extends LitElement {
    static styles = Styles;

    static properties = {
        commentsData: { type: Array },
        dataAddCommentsPerm: { type: Boolean },
        dataMarkFeaturedPerm: { type: Boolean },
        videoSlug: { type: String },
    };

    get hasComments() {
        return this.commentsData?.length > 0;
    }

    render() {
        if (!this.hasComments) {
            return nothing;
        }

        return html`
            <ul class="comments__list">
                ${this.commentsData.map(
                    (c) => html`
                        <vm-video-comments-list-item
                            .comment=${c}
                            .dataAddCommentsPerm=${this.dataAddCommentsPerm}
                            .dataMarkFeaturedPerm=${this.dataMarkFeaturedPerm}
                            .videoSlug=${this.videoSlug}
                            .isReply=${c.isReply || false}
                        ></vm-video-comments-list-item>
                    `,
                )}
            </ul>
        `;
    }
}
